export class PaymentFull {
    method: string;
    modality: string;
    parcels: number;
    totalValue: number;

	constructor() {
	
	}
}